/**
 * 組合員の声掲載検索用VO
 *
 */
export class SelectPublishVoiceModel {

  /**
   * 生協コード
   */
  public coopCode: string = <string>'';

  /**
   * 受注コード
   */
  public orderCode: string = <string>'';

  /**
   * 選択Ｐコード
   */
  public selectPcode: string = <string>'';

  /**
   * 注文商品区分
   */
  public orderGoodsFlg: string = <string>'';

  /**
   * 受付開始受注コード
   */
  public receiptSOrderCode: string = <string>'';

  /**
   * 注文コード
   */
  public orderNum6Digits: string = <string>'';

  /**
   * アイテムコード
   */
  public itemCode: string = <string>'';

}
